export default __webpack_public_path__ + "logo.5af40f33de37dfe73936e0c6e426b954.png";